import axios from "axios";
import { environment } from "../../../environments/environment";

export function getEngTasks(page, sorting, pageSize) {
    return axios.post(`${environment.getEngTasks}?page=${page ?? 0}&sorting=${sorting || ""}&pageSize=${pageSize ?? environment.ElemensPerPage}`,[{"columnName": "companyId", value: parseInt(localStorage.getItem('u_company_id'))}]);
}

export function getEtItem(id){
    return axios.get(`${environment.getEtItem}?id=${id}`)

}
export function getEtSchedule(id){
    return axios.get(`${environment.getSchedule}?engineeringTaskId=${id}`)

}